import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import '../../../css/EngagementTable.less';

import { SatCoreRegister } from '../../../SatCoreRegistry';

import { register } from '../../../i18n';

import EngagementService from '../../../services/EngagementService';

const EngagementHeaderMainLanguageToolUsageCells = observer((props) => {
  const { engagementManager } = useContext(MobXProviderContext);

  const activeTable = engagementManager.activeEngagementTable;

  const { handleHeaderClick } = props;

  const t = register('EngagementTable');

  const renderEngagementHeaderMainLanguageToolUsageCells = () => {
    const isOnlyShowingMainCells = activeTable === 'summary';
    return (
      <>
        {isOnlyShowingMainCells && renderEngagementHeaderMainLanguageToolUsageCell({
          allowPopupComponent: true,
          className: `main-cell engagement-header-label languageToolUsage active-table-${activeTable}`,
          isHeaderCell: true,
          popupContent: t('languageToolUsageDescriptionMain'),
          popupOn: 'hover',
          popupTrigger: (
            <div className='clickable'
              data-value='languageToolUsage'
              onClick={handleHeaderClick}>
              {t('languageToolUsage')}
            </div>
          )
        })}
        {!isOnlyShowingMainCells && renderEngagementHeaderMainLanguageToolUsageCell({
          allowPopupComponent: true,
          cellText: t('languageToolUsage'),
          className: `main-cell engagement-header-label languageToolUsage active-table-${activeTable}`,
          isHeaderCell: true,
          popupContent: t('languageToolUsageDescription'),
          popupOn: 'click'
        })}
      </>
    );
  };

  const renderEngagementHeaderMainLanguageToolUsageCell = (props = {}) => {
    return EngagementService.renderEngagementCell(props);
  };

  return renderEngagementHeaderMainLanguageToolUsageCells();
});
export default EngagementHeaderMainLanguageToolUsageCells;

SatCoreRegister('EngagementHeaderMainLanguageToolUsageCells', EngagementHeaderMainLanguageToolUsageCells);
